import { AppNav } from '@farmersdog/corgi-x';

import config from '../../config';

import { DiscountBanner } from './DiscountBanner';
import styles from './Navigation.css';
import { useItems } from './useItems';

export function Navigation() {
  const items = useItems();
  const websiteUrl = config.get('app.websiteUrl');

  return (
    <>
      <DiscountBanner />
      <div className={styles.navigation}>
        <AppNav logoTo={websiteUrl} shiftLogoUp {...items} />
      </div>
    </>
  );
}
